module.exports = __webpack_public_path__ + "img/5632b17.png";